// To match the fields in the API,
// this file defines the following constants in value to label format:
// Key is the value to be sent to the API request, value is the label to be displayed in the UI.

const YEARLY_CHOICES = {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December'
};

const WEEKLY_CHOICES = {
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
    7: 'Sunday'
};

const FREQUENCY_CHOICES = {
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    yearly: 'Yearly'
};

const RESOLUTION_CHOICES = {
    hourly: 'Hourly',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly'
};

const REPORT_TYPE_CHOICES = {
    trends: 'Trends',
    kpi: 'KPI',
    losses: 'Losses',
    data_entry_performance: 'Data Entry',
    maintenance_extended: 'Maintenance',
    phases: 'Phases',
    quality: 'Quality',
    benchmark: 'Benchmark'
};

const REPORT_TYPE_LEGACY_CHOICES = {
    kpi_trends: 'Trends (Legacy)',
    maintenance: 'Maintenance (Legacy)'
};

const REPORT_DATE_RANGE_CHOICES = {
    '24 hours': 'Last 24 hours',
    '7 days': 'Last 7 days',
    month: 'Last Month'
};

const FILE_FORMAT_CHOICES = {
    CSV: 'CSV',
    XLSX: 'XLSX'
};

export {
    FILE_FORMAT_CHOICES,
    FREQUENCY_CHOICES,
    REPORT_DATE_RANGE_CHOICES,
    REPORT_TYPE_CHOICES,
    REPORT_TYPE_LEGACY_CHOICES,
    RESOLUTION_CHOICES,
    WEEKLY_CHOICES,
    YEARLY_CHOICES
};
